<template>
    <div class="category-alert"
         :class="[types[props.selected].classSettings, {'rounded':props.lessRound,'rounded-md': !props.lessRound, 'pa-5': $vuetify.display.mdAndUp, 'pa-2': $vuetify.display.smAndDown, 'px-0': noBorder}]">
        <v-container class="pa-3">
            <v-row :class="{
                'gc-5': $vuetify.display.mdAndUp,
                'align-center': $vuetify.display.mdAndUp || props.selected != 'universal' && props.selected != 'universal-alt',
                'gc-3': $vuetify.display.smAndDown
            }">
                <v-col cols="auto" class="pa-0">
                    <v-icon
                        :icon="types[props.selected].icon"
                        :color="types[props.selected].color"
                        :size="types[props.selected].size"
                    ></v-icon>
                </v-col>
                <v-col class="pa-0" :class="{
                    'd-flex ga-1 flex-wrap': types[props.selected].one_line
                }">
                    <div v-html="types[props.selected].line1.value" :class="types[props.selected].line1.class"></div>
                    <p class="text-body-1" v-if="types[props.selected].line2" style="display: flex; align-items: flex-end">
                        <span v-html="types[props.selected].line2.value"
                              :class="types[props.selected].line2.class"></span>
                        <v-btn v-if="types[props.selected].line2.link"
                               @click="action(types[props.selected].line2.link.action)" variant="text" density="compact"
                               :color="types[props.selected].line2.color || types[props.selected].color"
                               class="pa-0 px-1 text-body-3 text-none text-decoration-underline">
                            {{ types[props.selected].line2.link.value }}
                            <template v-slot:append>
                                <v-icon class="ml-n2"
                                        :color="types[props.selected].line2.color || types[props.selected].color"
                                        :icon="types[props.selected].line2.link.icon"></v-icon>
                            </template>
                        </v-btn>
                    </p>
                </v-col>
                <v-col v-if="types[props.selected].button && $vuetify.display.mdAndUp" class="pa-0 d-flex flex-column align-end" cols="auto">
                    <v-btn elevation="0" class="ma-0 text-none pa-3" :class="types[props.selected].button.class"
                           :size="types[props.selected].button.size || 'large'" :color="types[props.selected].button.color ?? types[props.selected].color"
                           @click="action(types[props.selected].button.action)">
                        {{ types[props.selected].button.text }}
                        <v-dialog
                            v-if="types[props.selected].button.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                    </v-btn>
                    <v-btn v-if="types[props.selected].underButton?.value" variant="text" :ripple="false" density="compact" :color="types[props.selected].underButton.color"
                           class="px-1 py-0 mt-2 text-body-3 text-none text-decoration-underline"
                           :class="{'pl-4 ml-n2': types[props.selected].underButton.icon}"
                           @click="action(types[props.selected].underButton.action)">
                        {{ types[props.selected].underButton.value }}
                        <v-dialog
                            v-if="types[props.selected].underButton.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                        <template v-slot:prepend v-if="types[props.selected].underButton.icon">
                            <v-icon class="ml-n2" size="small" :color="types[props.selected].underButton.color" :icon="types[props.selected].underButton.icon"></v-icon>
                        </template>
                    </v-btn>
                </v-col>
                <v-col v-if="types[props.selected].links && $vuetify.display.mdAndUp"
                       v-for="(link, i) in types[props.selected].links" class="pa-0" cols="auto" align-self="end">
                    <v-btn v-if="link.value" variant="text" :ripple="false" density="compact" :color="link.color"
                           class="px-1 py-0 text-body-3 text-none text-decoration-underline"
                           @click="action(link.action)"
                           :class="{'pl-4 ml-n2': link.icon}">
                        {{ link.value }}
                        <v-dialog
                            v-if="link.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                        <template v-slot:prepend v-if="link.icon">
                            <v-icon class="ml-n2" size="small" :color="link.color" :icon="link.icon"></v-icon>
                        </template>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="$vuetify.display.smAndDown" class="gc-6 justify-center justify-sm-end">
                <v-col v-if="types[props.selected].button" class="pa-0 mt-2" cols="12">
                    <v-btn elevation="0" block class="text-none" :color="types[props.selected].color"
                           @click="action(types[props.selected].button.action)">
                        {{ types[props.selected].button.text }}
                        <v-dialog
                            v-if="types[props.selected].button.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                    </v-btn>
                    <v-btn v-if="types[props.selected].underButton?.value" variant="text" :ripple="false" density="compact" :color="types[props.selected].underButton.color"
                           class="px-1 py-0 mt-2 text-body-3 text-none text-decoration-underline"
                           :class="{'pl-4 ml-n2': types[props.selected].underButton.icon}"
                           @click="action(types[props.selected].underButton.action)">
                        {{ types[props.selected].underButton.value }}
                        <v-dialog
                            v-if="types[props.selected].underButton.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                        <template v-slot:prepend v-if="types[props.selected].underButton.icon">
                            <v-icon class="ml-n2" size="small" :color="types[props.selected].underButton.color" :icon="types[props.selected].underButton.icon"></v-icon>
                        </template>
                    </v-btn>
                </v-col>
                <v-col v-if="types[props.selected].links" v-for="(link, i) in types[props.selected].links" class="pa-0"
                       cols="auto">
                    <v-btn v-if="link.value" variant="text" :ripple="false" density="compact" :color="link.color"
                           class="px-1 py-0 mt-2 text-body-3 text-none text-decoration-underline"
                           :class="{'pl-4 ml-n2': link.icon}"
                           @click="action(link.action)">
                        {{ link.value }}
                        <v-dialog
                            v-if="link.action === 'show-compatibility'"
                            v-model="compatibilityModel"
                            activator="parent"
                            scrollable
                            width="800"
                        >
                            <compatibility-list
                                :product-id="product.id"
                                :product-name="product.name"
                                @close="compatibilityModel = false"
                            ></compatibility-list>
                        </v-dialog>
                        <template v-slot:prepend v-if="link.icon">
                            <v-icon class="ml-n2" size="small" :color="link.color" :icon="link.icon"></v-icon>
                        </template>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'vuetify/lib/styles/settings/colors' as *;
@use 'sass:map';

.category-alert {
    &.border-purple {
        border: 1px solid map.get($purple, lighten-4);
    }

    &.border-blue {
        border: 1px solid map.get($blue, base);
    }

    &.border-orange {
        border: 1px solid map.get($orange, lighten-2);
    }

    &.border-red {
        border: 1px solid map.get($red, base);
    }
}
</style>
<script setup>
import {mdiChevronDown, mdiClose, mdiInformationOutline, mdiAtv} from "@mdi/js";
import {inject, defineAsyncComponent, ref, computed} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import {useSearchStore} from "../../../../frontend/motonet/components/store/search.js";
import pinia from "../../../../plugins/pinia.js";
import {useOverlayModalsStore} from "../../../../frontend/motonet/components/store/overlayModals.js";
import {trans} from "laravel-vue-i18n";

const CompatibilityList = defineAsyncComponent(() => import('./CompatibilityList.vue'))

const store = useSearchStore(pinia);
const modelSearchStore = useOverlayModalsStore(pinia);
const props = defineProps({
    selected: String,
    selectedBike: Object,
    lessRound: Boolean,
    productDetail: Boolean,
    productDetailTop: Boolean,
    niceButton: Boolean,
    product: Object,
    noBorder: Boolean,
})
const compatibilityModel = ref(false);
const route = inject('route');
const types = computed(() => {
    const user = usePage().props.customer;
    const canShowCompatibility = user?.is_dealer;
    return {
    'not-compatible': {
        icon: mdiAtv,
        line1: {
            value: trans('category-alert.product_not_compatible_with'),
            class: 'text-red text-body-1 font-weight-black'
        },
        line2: {
            value: props.selectedBike?.full_name,
            color: 'black',
            link: {
                value: trans('category-alert.change_model'),
                icon: mdiChevronDown,
                action: 'select-bike'
            }
        },
        color: 'red',
        size: '48',
        button: {
            action: canShowCompatibility ? 'show-compatibility' : 'show-everything',
            text: canShowCompatibility ? trans('category-alert.show_full_compatibility') : trans('category-alert.show_all_for_motorbike'),
            class: 'text-body-2 w-auto px-3',
            size: 40,
            color: 'white'
        },
        classSettings: 'bg-red-lighten-5' + (props.noBorder ? '' : ' border-red')
    },
    'universal': {
        icon: mdiInformationOutline,
        line1: {
            value: props.productDetail ? trans('category-alert.this_product_is_universal') : trans('category-alert.you_are_in_universal_category'),
            class: 'text-purple text-body-1 font-weight-black'
        },
        line2: {
            value: props.productDetail ? '' : trans('category-alert.these_products_fit_all'),
            class: 'font-weight-light'
        },
        one_line: true,
        color: 'purple',
        size: '24',
        classSettings: 'bg-purple-lighten-6' + (props.noBorder ? '' : ' border-purple')
    },
    'select-bike': {
        icon: mdiAtv,
        line1: {
            value: trans('category-alert.enter_vehicle_type'),
            class: 'text-body-1 font-weight-black mb-1'
        },
        line2: {
            value: trans('category-alert.without_it_we_cant_find_compatible_products'),
            class: 'font-weight-light'
        },
        color: 'blue',
        size: '48',
        button: {
            action: 'select-bike',
            text: trans('category-alert.enter_motorbike'),
            class: 'text-body-2 w-auto px-3',
            size: 40
        },
        underButton: {
            value: props.productDetailTop ? (canShowCompatibility ? trans('category-alert.show_full_compatibility') : undefined) : undefined,
            action: props.productDetailTop ? 'show-compatibility' : 'show-everything',
            color: 'orange'
        },
        classSettings: 'bg-blue-lighten-4' + (props.noBorder ? '': ' border-blue')
    },
    'selected-bike': {
        icon: mdiAtv,
        line1: {
            value: props.productDetail ? trans('category-alert.product_compatible_with') : trans('category-alert.displaying_items_compatible_with'),
            class: 'text-body-1 font-weight-black'
        },
        line2: {
            value: props.selectedBike?.full_name,
            class: 'font-weight-light',
            link: {
                value: trans('category-alert.change_model'),
                icon: mdiChevronDown,
                action: 'select-bike'
            }
        },
        links: [
            {
                value: props.productDetailTop ? (canShowCompatibility ? trans('category-alert.show_full_compatibility') : undefined) : trans('category-alert.show_all_for_motorbike'),
                action: props.productDetailTop ? 'show-compatibility' : 'show-everything',
                color: 'orange'
            },
            {
                value: props.productDetailTop ? undefined : trans('category-alert.cancel_filter'),
                icon: mdiClose,
                action: 'remove-bike',
                color: 'black'
            }
        ],
        color: 'orange',
        size: '48',
        classSettings: 'bg-orange-lighten-4' + (props.noBorder ? '' : ' border-orange')
    },
    'tire-search': {
        icon: mdiInformationOutline,
        line1: {
            value: trans('category-alert.the_tire_searcher_does_not_take_into_account_the_filtered_motorcycle'),
            class: 'font-weight-black text-purple'
        },
        color: 'purple',
        size: '24',
        classSettings: 'bg-purple-lighten-6' + (props.noBorder ? '' : ' border-purple')
    },
}})

const action = (action) => {
    switch (action) {
        case 'select-bike':
            modelSearchStore.toggleModelSearchOpen();
            break;
        case 'show-everything':
            router.visit(props.selectedBike?.url);
            break;
        case 'remove-bike':
            router.visit(route('eshop.forgetModelSearch'));
            store.resetSelected();
            break;
    }
}
</script>
